<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->
  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <!-- loading component -->
    <Loading />
    <b-card style="border: 0" class="mt-0 mb-0">
      <h3>
        کد رساله دکتری:
        {{ proposal.requestsCode }}
      </h3>
      <h4 class="text-dark">وضعیت رساله دکتری: {{ proposal.status }}</h4>

      <hr />
      <v-btn
        style="float: left"
        v-if="tabIndex == 0"
        class="bc-purple"
        @click="saveDocx('doc')"
        elevation="0"
      >
        <v-icon small class="fa fa-file-word-o pe-2 white--text"></v-icon>
        <span class="white--text text-capitalize"> دریافت Word </span>
      </v-btn>
      <b-tabs pills v-model="tabIndex">
        <!-- docx -->
        <div v-show="false" id="doc">
          <div class="all" style="text-align: right">
            <h1
              style="
                display: inline-block;
                text-align: center;
                padding: 5px 0;
                border-bottom: 3px solid black;
              "
            >
              کد رساله دکتری:
              <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
                proposal.requestsCode
              }}</span>
            </h1>
            <div>
              <h2 style="color: black; direction: rtl">
                تاریخ خروجی: {{ exportDate }}
              </h2>
              <hr />
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                عنوان و حمایت‌های پیشین
              </h2>
              <div>
                <ul>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>عنوان رساله دکتری: </strong>{{ proposal.faSubject }}
                  </li>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>تاریخ ثبت پروپوزال: </strong
                    ><span style="direction: ltr">{{
                      proposal.dateProposalSubmission
                    }}</span>
                  </li>
                  <li
                    :class="proposal.masterThesisSubject ? 'done' : 'required'"
                  >
                    <strong>عنوان پایان‌نامه ارشد: </strong
                    >{{ proposal.masterThesisSubject }}
                  </li>

                  <li>
                    <strong>عنوان پروژه کارشناسی (در صورت وجود): </strong>
                    {{
                      proposal.bachelorProjectSubject
                        ? proposal.bachelorProjectSubject
                        : "فاقد پروژه کارشناسی"
                    }}
                  </li>
                  <li
                    :class="proposal.initialIsSupported ? 'done' : 'required'"
                  >
                    <strong
                      >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                      کرده است؟
                    </strong>

                    {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                  </li>

                  <li
                    v-if="proposal.initialIsSupported"
                    :class="proposal.initialSupportedType ? 'done' : 'required'"
                  >
                    <strong> حمایت ها: </strong
                    >{{
                      requestsOptions.filter(
                        (x) => x.value == proposal.initialSupportedType
                      )[0].text
                    }}
                  </li>
                  <li
                    v-if="
                      proposal.initialSupportedType == 'other' &&
                      proposal.initialIsSupported
                    "
                    :class="proposal.initialOtherSupport ? 'done' : 'required'"
                  >
                    <strong>عنوان حمایت دریافتی: </strong>
                    {{ proposal.initialOtherSupport }}
                  </li>
                  <li
                    v-if="proposal.initialIsSupported"
                    :class="
                      proposal.initialSupportDescription ? 'done' : 'required'
                    "
                  >
                    <strong>توضیحات حمایت دریافتی: </strong><br />
                    {{ proposal.initialSupportDescription }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات اصلی رساله دکتری
              </h2>
              <div>
                <ul>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>عنوان به زبان فارسی: </strong
                    >{{ proposal.faSubject }}
                  </li>
                  <li :class="proposal.enSubject ? 'done' : 'required'">
                    <strong>عنوان به زبان انگلیسی: </strong
                    >{{ proposal.enSubject }}
                  </li>
                  <li :class="proposal.universityId ? 'done' : 'required'">
                    <strong>دانشگاه محل اجرای رساله دکتری: </strong>
                    {{
                      proposal.universityId
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0].text
                          : ""
                        : ""
                    }}
                  </li>
                  <li
                    v-if="proposal.universityId == notUniversity"
                    :class="proposal.otherUniversity ? 'done' : 'required'"
                  >
                    <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                  </li>
                  <li
                    v-if="proposal.mehvarId != notMehvar"
                    :class="proposal.mehvarId ? 'done' : 'required'"
                  >
                    <strong>محور رساله دکتری: </strong>
                    {{
                      proposal.mehvarId
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                          ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                              .text
                          : ""
                        : ""
                    }}
                  </li>
                  <li
                    v-if="proposal.mehvarId == notMehvar"
                    :class="proposal.mehvarId ? 'done' : 'required'"
                  >
                    <strong>محور رساله دکتری: </strong> سایر محورها
                  </li>

                  <li
                    v-if="proposal.mehvarId == notMehvar"
                    :class="proposal.otherMehvars ? 'done' : 'required'"
                  >
                    <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                  </li>
                  <li>
                    <strong>ماهیت رساله دکتری: </strong>
                    <ul>
                      <li v-if="proposal.typeStudy">مطالعاتی</li>
                      <li v-if="proposal.typeSystemicDevelopmental">
                        سیستمی و توسعه‌ای
                      </li>
                      <li v-if="proposal.typePractical">کاربردی</li>
                    </ul>
                  </li>
                  <li>
                    <strong>حوزه رساله دکتری: </strong>
                    <ul>
                      <li v-if="proposal.zoneMedicine">پزشکی</li>
                      <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                      <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                      <li v-if="proposal.zoneIndustrial">صنعتی</li>
                      <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                      <li v-if="proposal.zoneOther">سایر</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات دانشجو
              </h2>
              <div>
                <ul>
                  <li :class="proposal.researcherName ? 'done' : 'required'">
                    <strong>نام: </strong>{{ proposal.researcherName }}
                  </li>
                  <li
                    :class="proposal.researcherLastName ? 'done' : 'required'"
                  >
                    <strong>نام خانوادگی: </strong
                    >{{ proposal.researcherLastName }}
                  </li>
                  <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                    <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                  </li>
                  <li :class="proposal.researcherMobile ? 'done' : 'required'">
                    <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                  </li>
                  <li :class="proposal.researcherFax ? 'done' : 'required'">
                    <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                  </li>
                  <li :class="proposal.researcherEmail ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong
                    >{{ proposal.researcherEmail }}
                  </li>
                  <li :class="proposal.researcherState ? 'done' : 'required'">
                    <strong>استان: </strong>{{ proposal.researcherState }}
                  </li>
                  <li :class="proposal.researcherCity ? 'done' : 'required'">
                    <strong>شهر: </strong>{{ proposal.researcherCity }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityId ? 'done' : 'required'
                    "
                  >
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{
                      proposal.researcherUniversityId
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityOther ? 'done' : 'required'
                    "
                    v-if="proposal.researcherUniversityId == notUniversity"
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ proposal.researcherUniversityOther }}
                  </li>
                  <li
                    :class="
                      proposal.researcherStudentNumber ? 'done' : 'required'
                    "
                  >
                    <strong>شماره دانشجویی: </strong
                    >{{ proposal.researcherStudentNumber }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اساتید رساله دکتری
              </h2>
              <div>
                <strong>تعداد اساتید رساله دکتری : </strong>
                {{ proposal.teachers.length }}
                <div v-for="(prof, index) in proposal.teachers" :key="index">
                  <strong style="color: blue"
                    >استاد شماره {{ index + 1 }}</strong
                  >
                  <ul>
                    <li :class="prof.name ? 'done' : 'required'">
                      <strong>نام: </strong>{{ prof.name }}
                    </li>
                    <li :class="prof.lastName ? 'done' : 'required'">
                      <strong>نام خانوادگی: </strong>{{ prof.lastName }}
                    </li>
                    <li :class="prof.natCode ? 'done' : 'required'">
                      <strong>کدملی: </strong>{{ prof.natCode }}
                    </li>
                    <li :class="prof.role ? 'done' : 'required'">
                      <strong>نقش استاد در پایان‌نامه: </strong
                      >{{ prof.role == "supervisor" ? "مشاور" : "راهنما" }}
                    </li>
                    <li :class="prof.mobile ? 'done' : 'required'">
                      <strong>تلفن همراه: </strong>{{ prof.mobile }}
                    </li>
                    <li :class="prof.email ? 'done' : 'required'">
                      <strong>پست الکترونیکی: </strong>{{ prof.email }}
                    </li>
                    <li :class="prof.position ? 'done' : 'required'">
                      <strong>سمت: </strong>{{ prof.position }}
                    </li>
                    <li :class="prof.universityId ? 'done' : 'required'">
                      <strong>دانشگاه محل تحصیل: </strong>
                      {{
                        prof.universityId
                          ? universities.filter(
                              (x) => x.id == prof.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == prof.universityId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      v-if="prof.universityId == notUniversity"
                      :class="prof.universityOther ? 'done' : 'required'"
                    >
                      <strong>نام دانشگاه: </strong>{{ prof.universityOther }}
                    </li>
                    <li>
                      <strong
                        >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:
                      </strong>
                      {{
                        prof.universityJobId
                          ? universities.filter(
                              (x) => x.id == prof.universityJobId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == prof.universityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li v-if="prof.universityJobId == notUniversity">
                      <strong>نام دانشگاه: </strong
                      >{{ prof.universityJobOther }}
                    </li>
                    <li :class="prof.lastDegree ? 'done' : 'required'">
                      <strong>آخرین مدرک تحصیلی: </strong>{{ prof.lastDegree }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات پروپوزال
              </h2>
              <div>
                <ul>
                  <li :class="proposal.problemStatement ? 'done' : 'required'">
                    <strong>بیان مساله: </strong><br />
                    {{ proposal.problemStatement }}
                  </li>
                  <li :class="proposal.requestNecessity ? 'done' : 'required'">
                    <strong>ضرورت تحقیق: </strong><br />
                    {{ proposal.requestNecessity }}
                  </li>
                  <li :class="proposal.researchQuestions ? 'done' : 'required'">
                    <strong>سوالات تحقیق (اصلی/فرعی): </strong><br />
                    {{ proposal.researchQuestions }}
                  </li>
                  <li
                    :class="proposal.researchHypotheses ? 'done' : 'required'"
                  >
                    <strong>فرضیات تحقیق (اصلی/فرعی): </strong><br />
                    {{ proposal.researchHypotheses }}
                  </li>
                  <li :class="proposal.majorGoals ? 'done' : 'required'">
                    <strong>اهداف تحقیق(اصلی/فرعی): </strong><br />
                    {{ proposal.majorGoals }}
                  </li>
                  <li
                    :class="
                      proposal.generalResearchMethod ? 'done' : 'required'
                    "
                  >
                    <strong>روش کلی تحقیق: </strong><br />
                    {{ proposal.generalResearchMethod }}
                  </li>
                  <li
                    :class="proposal.spatialScopeResearch ? 'done' : 'required'"
                  >
                    <strong>قلمرو مکانی تحقیق: </strong><br />
                    {{ proposal.spatialScopeResearch }}
                  </li>
                  <li
                    :class="proposal.researchTimeDomain ? 'done' : 'required'"
                  >
                    <strong>قلمرو زمانی تحقیق: </strong><br />
                    {{ proposal.researchTimeDomain }}
                  </li>
                  <li :class="proposal.researchSampling ? 'done' : 'required'">
                    <strong>روش نمونه گیری و تعیین حجم نمونه: </strong><br />
                    {{ proposal.researchSampling }}
                  </li>
                  <li
                    :class="proposal.dataCollectionMethod ? 'done' : 'required'"
                  >
                    <strong>روش گرد آوری داده ها و ابزار: </strong><br />
                    {{ proposal.dataCollectionMethod }}
                  </li>
                  <li :class="proposal.analysisMethod ? 'done' : 'required'">
                    <strong>روش های تحلیل داده ها: </strong><br />
                    {{ proposal.analysisMethod }}
                  </li>
                  <li :class="proposal.researchObstacles ? 'done' : 'required'">
                    <strong>موانع و محدودیت های تحقیق: </strong><br />
                    {{ proposal.researchObstacles }}
                  </li>
                  <li
                    :class="
                      proposal.researchMacroTheoreticalFramework
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>چارچوب کلان نظری تحقیق: </strong><br />
                    {{ proposal.researchMacroTheoreticalFramework }}
                  </li>
                  <li :class="proposal.keywords ? 'done' : 'required'">
                    <strong>شرح واژه ها و اصطلاحات: </strong><br />
                    {{ proposal.keywords }}
                  </li>
                  <li :class="proposal.references ? 'done' : 'required'">
                    <strong>فهرست منابع: </strong><br />
                    {{ proposal.references }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                معرفی شرکت دانش بنیان همکار
              </h2>
              <div>
                <ul>
                  <li
                    :class="
                      proposal.companyId
                        ? proposal.companyId != notCompany
                          ? 'done'
                          : proposal.otherCompanyName
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{
                      proposal.companyId != notCompany
                        ? proposal.companyName
                        : proposal.otherCompanyName
                    }}
                  </li>
                  <li
                    :class="
                      proposal.companyId
                        ? proposal.companyId != notCompany
                          ? 'done'
                          : proposal.otherCompanyRegistrationNumber
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{
                      proposal.companyId != notCompany
                        ? proposal.companyRegistrationNumber
                        : proposal.otherCompanyRegistrationNumber
                    }}
                  </li>
                  <li
                    :class="
                      proposal.companyId
                        ? proposal.companyId != notCompany
                          ? 'done'
                          : proposal.otherCompanyNationalId
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <strong>شناسه ملی شرکت: </strong
                    >{{
                      proposal.companyId != notCompany
                        ? proposal.companyNationalId
                        : proposal.otherCompanyNationalId
                    }}
                  </li>
                  <li :class="proposal.companyProducts ? 'done' : 'required'">
                    <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                    {{ proposal.companyProducts }}
                  </li>
                  <li :class="proposal.companyAddress ? 'done' : 'required'">
                    <strong>آدرس: </strong><br />
                    {{ proposal.companyAddress }}
                  </li>
                  <li :class="proposal.companyPostalCode ? 'done' : 'required'">
                    <strong>کد پستی: </strong><br />
                    {{ proposal.companyPostalCode }}
                  </li>
                  <li :class="proposal.companyTel ? 'done' : 'required'">
                    <strong>شماره تماس: </strong><br />
                    {{ proposal.companyTel }}
                  </li>
                  <li :class="proposal.companyEmail ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong><br />
                    {{ proposal.companyEmail }}
                  </li>
                  <li
                    :class="proposal.companyDescription ? 'done' : 'required'"
                  >
                    <strong>توضیحات: </strong><br />
                    {{ proposal.companyDescription }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                زمان‌بندی و فازبندی انجام رساله دکتری
              </h2>
              <div>
                <b>زمان شروع: </b>

                {{
                  proposal.gantData.length > 0
                    ? moment(
                        new Date(
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )
                        )
                      ).format("jDD/jMM/jYYYY")
                    : ""
                }}
                <br />
                <b>زمان پایان: </b>
                {{
                  proposal.gantData.length > 0
                    ? moment(
                        new Date(
                          Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )
                        )
                      ).format("jDD/jMM/jYYYY")
                    : ""
                }}
                <br />
                <b>مدت زمان: </b>
                {{
                  proposal.gantData.length > 0
                    ? (Math.max(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      ) -
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )) /
                        3600 /
                        24 /
                        1000 +
                      " روز"
                    : ""
                }}
                <br />
              </div>
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.gantData"
                :fields="serviceFieldsDoc"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                تعهدات
              </h2>
              <div>
                <ul>
                  <li v-if="proposal.promiseArrays[0]">
                    درج عبارت زیر در رساله و کلیه انتشارات،مقالات،سخنرانی
                    ها،اسلایدها و مانند آن انجام خواهد گرفت<br />
                    '' این پژوهش با کمک مالی شماره ....... ستاد توسعه زیست
                    فناوری انجام شده است''<br />
                    ''This study was financially supported bygrant NO:.... of
                    the Biotechnology Development Council of the Islamic
                    Republic of Iran''<br />
                    در صورت عدم درج،حمایت مرحله دوم صورت نخواهد گرفت.
                  </li>
                  <li v-if="proposal.promiseArrays[1]">
                    توافق بین دانشجو و صنعت برای بهره برداری از نتایج رساله وجود
                    دارد.
                  </li>
                  <li v-if="proposal.promiseArrays[2]">
                    نحوه تجاری سازی رساله مشخص است و مستندات ارائه شده است.
                  </li>
                  <li v-if="proposal.promiseArrays[3]">
                    فایل نهایی رساله،دستاوردها،ثبت اختراعات و مقالات پس از اتمام
                    رساله بارگذاری می شود.
                  </li>
                  <li v-if="proposal.promiseArrays[4]">
                    دعوتنامه جهت حضور در جلسه دفاع به حضور کارشناس گروه پژوهش
                    خواهد رسید.
                  </li>
                  <li v-if="proposal.promiseArrays[5]">
                    ثبت اطلاعات تعهدی برای حمایت نداشته و به منزله ثبت درخواست
                    است.
                  </li>
                  <li v-if="proposal.promiseArrays[6]">
                    پذیرفته شدن در بخش اول تعهدی برای حمایت از بخش دوم ایجاد نمی
                    کند و مدارک و اقدامات مربوط به بخش دوم در سامانه قابل ثبت و
                    بررسی خواهد بود.
                  </li>
                  <li v-if="proposal.promiseArrays[7]">
                    کلیه موارد فوق مورد تایید اینجانب
                    {{
                      proposal.researcherName +
                      " " +
                      proposal.researcherLastName
                    }}
                    می باشد.
                  </li>
                </ul>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <!-- docx -->
        <b-tab title="چکیده طرح" active lazy>
          <Phd
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :companies="companies"
            :isLoaded="isLoaded"
          />
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="isLoaded" />
        </b-tab>
        <!-- Project Control part -->
        <b-tab title="کنترل پروژه" active>
          <AcceleratorPc
            :acceleratorReport="acceleratorReport"
            :reportFiles="reportFiles"
            :type="'phd'"
          ></AcceleratorPc>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import AcceleratorPc from "../../components/AcceleratorPc.vue";
import Phd from "./../../components/AcceleratorPhd";
import Files from "./../../components/UploadedFiles";
export default {
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
    AcceleratorPc,
    Phd,
    Files,
  },
  data() {
    return {
      reports: [],
      reports2: [],
      reportFiles: [],
      acceleratorReport: {},
      companies: [],
      tabIndex: 3,
      max: 100,
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        { key: "url", label: "دریافت" },
      ],
      rev: "",
      requestsOptions: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      projectControl: [],
      isLoaded: true,
      expireDisable: false,
      loaded: false,
      moment: moment,
      show: false,
      fileBusy: true,
      proposalInfo: {},
      universities: [],
      source: "",
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      fileFilter: "",
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      proposal: {},
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      reviewerData: [],
      color: "",
      acc: 0,
      pageLoaded: false,
      reportFile: [],
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    showProject() {
      let acc = 0;
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            name: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );

          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/report/phd/getInfo",
          {
            reportId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data.request;
          this.acceleratorReport = res.data.report;
          this.acceleratorReport.judge = "";
          this.acceleratorReport.judgePercent = "";
          this.acceleratorReport.judgeDescription = "";
          this.reportFiles.push({
            name: "گزارش",
            url: this.acceleratorReport.file,
          }),
            this.acceleratorReport.financeFile
              ? this.reportFiles.push({
                  name: "درخواست مالی",
                  url: this.acceleratorReport.financeFile,
                })
              : "",
            this.acc++;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            // this.busyAll = false;
          }

          setTimeout(() => {
            this.pageLoaded = true;
            this.show = true;
          }, 200);
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.$router.push("/accelerator/pcReports");
        });
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.showProject();
  },
};
</script>
<style scoped lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}

.contract-section {
  .custom-control-inline {
    margin-right: 0 !important;
  }
}

.diabled-textarea {
  color: grey;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  min-height: 45px;
  position: relative;
  padding-top: 10px;
  background-color: #e4e7ea;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
#forceFinishedModal___BV_modal_header_ {
  button {
    margin: -1rem !important;
  }
}
</style>
